import { gql } from "@apollo/client";

export const GET_REGISTRATION_STATUS_QUERY = gql`
  query ExternalSettings($input: ExternalSettingsInput!) {
    externalSettings(input: $input) {
      show
      showCount
      enableEstatePresentation
      products {
        showBoligpresentasjon
      }
    }
  }
`;

export const GET_VIEWINGS_QUERY = gql`
  query GetViewings($input: ExternalGetAllViewingsInput!) {
    externalGetAllViewings(input: $input) {
      identifier
      date
      dateFormatted
      from
      to
      maxParticipants {
        value
      }
    }
  }
`;

export const GET_VIEWING_QUERY = gql`
  query GetViewing($input: GetExternalViewingInput!) {
    externalGetViewing(input: $input) {
      interval
      available {
        info {
          noTimesWithoutParticipants
          items {
            from
            to
            availableSlots
            participants
            firstWithNoParticipants
          }
        }
      }
    }
  }
`;

export const GET_CONSENTS = gql`
  query GetConsentsByIds($ids: [Int]) {
    getAvailableSamtykkerByIds(ids: $ids) {
      id
      samtykketekst
    }
  }
`;
